import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import LoginForm from "./LoginForm";
import { toast } from 'react-toastify';
import UpdateUserModal from "./UpdateUserModal";
import ResetPasswordModal from "./ResetPasswordModal";
import ContactForm from "./ContactForm";
import Header from "./Header";
import Footer from "./Footer";
import AdminPanel from "./AdminPanel";
import { UserIcon } from '@heroicons/react/24/solid'; 


function FileUpload() {
  console.log("✅ FileUpload komponenta renderirana");
  const [showRegistration, setShowRegistration] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
const [progress, setProgress] = useState(0);
const [progressMap, setProgressMap] = useState({});
const [isAdmin, setIsAdmin] = useState(false);
const [userInfo, setUserInfo] = useState(null);
const [dragActive, setDragActive] = useState(false);



  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState(""); // pozneje jo pridobiš iz backenda
  const [files, setFiles] = useState([]);


  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });
  const navigate = useNavigate();
    const startDeepAnalysis = (documentId) => {
  return new Promise((resolve, reject) => {
    const es = new EventSource(`https://fnm-backend.aibc-robotics.com/deep-analyze-stream?document_id=${documentId}`);

    es.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.progress !== undefined) {
        setProgressMap((prev) => ({
          ...prev,
          [documentId]: data.progress,
        }));
      }
      if (data.complete) {
        es.close();
        setProgressMap((prev) => ({
          ...prev,
          [documentId]: 100,
        }));
        resolve();
      }
    };

    es.onerror = (err) => {
      console.error("Napaka pri streamu:", err);
      es.close();
      reject(err);
    };
  });
};

  useEffect(() => {
    const savedLogin = localStorage.getItem("isLoggedIn");
    if (savedLogin === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setShowLogin(true); // pokaži login modal
  };


const handleLogout = () => {
  localStorage.clear();
  setIsLoggedIn(false);
  setUserName("");
  setUserInfo(null); // ⬅️ To je ključno!
  setIsAdmin(false);
  setFiles([]);
  toast.success("Uspešno si se odjavil iz platforme!");
};



const fetchUserInfo = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) return;

  try {
    const res = await axios.get("https://fnm-backend.aibc-robotics.com/me", {
      headers: {
        "X-User-ID": userId,
      },
    });

    const user = res.data;
    console.log(user)

    setUserInfo(user); // 🔥 Shrani vse podatke
    setUserName(`${user.ime} ${user.priimek}`);
    setIsAdmin(user.vloga === "admin" && user.potrjen === true); // ✅ Admin in potrjen

  } catch (err) {
    console.error("Napaka pri pridobivanju uporabnika:", err);
  }
};


  useEffect(() => {
    const savedLogin = localStorage.getItem("isLoggedIn");
    if (savedLogin === "true") {
      setIsLoggedIn(true);
      fetchUserInfo();  // <-- tukaj dodaj
    }
  }, []);



const handleUpload = async () => {
  if (!files || files.length === 0) return;

  // 🔒 Preveri da so vse datoteke PDF
  const nonPdf = files.find(f => !f.name.toLowerCase().endsWith(".pdf"));
  if (nonPdf) {
    toast.error(`❌ Samo PDF datoteke so dovoljene (odstrani: ${nonPdf.name})`);
    return;
  }

  setLoading(true);
  try {
    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));

    const uploadRes = await axios.post("https://fnm-backend.aibc-robotics.com/upload", formData);
    const uploaded = uploadRes.data;

    const analyzedIds = [];

    for (const doc of uploaded) {
      if (doc.document_id) {
        await startDeepAnalysis(doc.document_id);
        analyzedIds.push(doc.document_id);
      }
    }

    if (analyzedIds.length > 0) {
      navigate(`/results/${analyzedIds.join(",")}`);
    }
  } catch (err) {
    console.error("Napaka pri nalaganju:", err);
  } finally {
    setLoading(false);
    setProgress(0);
    localStorage.removeItem("suggestions_cache");
  }
};


const progressValues = Object.values(progressMap);
const averageProgress =
  progressValues.length > 0
    ? Math.round(progressValues.reduce((sum, p) => sum + p, 0) / progressValues.length)
    : 0;




  return (
    <div className="min-h-screen flex flex-col items-center justify-between bg-gray-100 pt-24">

      <Header
        isLoggedIn={isLoggedIn}
        userName={userName}
        onLogin={() => setShowLogin(true)}
        onLogout={handleLogout}
        onUpdate={() => setShowUpdateModal(true)}
        onReset={() => setShowResetModal(true)}
        onRegister={() => setShowRegistration(true)} // ✅ dodaj to
      />

    {userInfo?.vloga === "admin" && userInfo?.potrjen && <AdminPanel />}





      {showLogin && (
        <LoginForm
          onSuccess={() => {
            setIsLoggedIn(true);
            fetchUserInfo();        // 🔥 DODANO – takoj pridobi ime
            setShowLogin(false);    // 🔒 Skrij modal po uspešni prijavi
          }}
          onClose={() => setShowLogin(false)}
        />
      )}


      {/* Gumbi za prijavo/registracijo/odjavo */}
      <div className="absolute top-6 right-6 space-x-4">
        {!isLoggedIn ? (
          <>
            <button
              onClick={() => setShowRegistration(true)}
              className="px-4 py-2 bg-white border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition"
            >
              Registracija
            </button>

            <button
              onClick={handleLogin}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            >
              Prijava
            </button>
          </>
          
        ) : (
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
          >
            Odjava
          </button>
        )}
        
      </div>
      

      {/* Glavna vsebina */}
      {showRegistration && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
          onClick={() => setShowRegistration(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <RegistrationForm onClose={() => setShowRegistration(false)} />
          </div>
        </div>
      )}
      {showUpdateModal && (
        <UpdateUserModal
          onClose={() => setShowUpdateModal(false)}
          onUpdated={(newName) => setUserName(newName)}
        />
      )}
      {showResetModal && (
        <ResetPasswordModal onClose={() => setShowResetModal(false)} />
      )}



        {isLoggedIn ? (
    <div className="flex-grow flex justify-center items-center w-full">
      <div className="bg-white p-10 rounded-2xl shadow-xl w-full max-w-2xl text-center">

          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Naloži učni načrt (PDF)</h2>

<div
  className={`border-2 rounded-lg p-10 bg-gray-50 mb-6 min-h-[250px] flex flex-col items-center justify-center text-center
  ${dragActive ? 'border-blue-500 border-dashed bg-blue-50' : 'border-gray-300 border-dashed'}`}
  onDragOver={(e) => {
    e.preventDefault();
    setDragActive(true);
  }}
  onDragLeave={() => setDragActive(false)}
  onDrop={(e) => {
    e.preventDefault();
    setDragActive(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    const validPdfs = droppedFiles.filter(file => file.name.toLowerCase().endsWith(".pdf"));
    if (validPdfs.length < droppedFiles.length) {
      toast.error("❌ Dovoljene so samo PDF datoteke!");
    }
    setFiles((prev) => [...prev, ...validPdfs]);
  }}
>

  <p className="text-gray-500 mb-2">Povleci in spusti datoteko tukaj</p>
  <p className="text-sm text-gray-400">ali</p>
  <div className="mt-2">
    <label className="cursor-pointer text-blue-600 hover:underline">
      Izberi datoteko
      <input
        type="file"
        accept=".pdf"
        multiple
        className="hidden"
        onChange={(e) => {
          const selectedFiles = Array.from(e.target.files);
          const validPdfs = selectedFiles.filter(file =>
            file.name.toLowerCase().endsWith(".pdf")
          );
          if (validPdfs.length < selectedFiles.length) {
            toast.error("❌ Dovoljene so samo PDF datoteke!");
          }
          setFiles((prev) => [...prev, ...validPdfs]);
        }}
      />
    </label>
  </div>

  {files.length > 0 && (
    <ul className="text-sm mt-4 text-green-600 text-left space-y-1 w-full">
      {files.map((f, idx) => (
        <li
          key={idx}
          className="flex justify-between items-center bg-green-50 px-2 py-1 rounded border border-green-200"
        >
          <span>✅ {f.name}</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setFiles((prev) => prev.filter((_, i) => i !== idx));
            }}
            className="text-red-600 hover:text-red-800 text-xs ml-2"
          >
            ✕
          </button>
        </li>
      ))}
    </ul>
  )}
</div>


{loading ? (
  <div className="w-full mt-2 py-2 rounded-lg bg-gray-200 text-gray-800 font-semibold flex flex-col items-center">
    <div className="w-full bg-gray-300 h-4 rounded-full overflow-hidden">
      <div
        className="bg-blue-600 h-4"
        style={{ width: `${averageProgress}%`, transition: "width 0.2s" }}
      ></div>
    </div>
    <span className="mt-2 text-sm">{averageProgress}% analizirano</span>
  </div>
) : (
  <button
    onClick={handleUpload}
    className="w-full mt-2 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
  >
    Naloži in analiziraj
  </button>
)}


        </div>
        </div>
        
      ) : (
        <div className="flex flex-col items-center text-center opacity-70 select-none">
          <div className="text-6xl mb-4">📄</div>
          <div className="bg-white p-14 rounded-2xl shadow-xl w-full max-w-3xl">


            <h2 className="text-xl font-semibold text-gray-800 mb-2">Naloži učni načrt (PDF)</h2>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-12 bg-gray-100 min-h-[400px] flex flex-col justify-center items-center">


              <p className="text-gray-400 mb-2">Nalagalnik je zaklenjen</p>
              <p className="text-gray-400 text-lg mt-4">🔒 Prijava je potrebna za nalaganje dokumentov</p>

            </div>
          </div>
          <p className="text-gray-600 text-lg mt-6">
            Za nalaganje dokumenta se prosim <span className="font-semibold">prijavi</span>.
          </p>


        </div>
        
      )}
      <div className="mt-10 mb-6">

      {!isLoggedIn && (
        <div className="mt-10 mb-16">
          <ContactForm />
        </div>
      )}



</div>
  <Footer />

    </div>
    
  );
}

export default FileUpload;
